<template>
  <div class="d-flex flex-column align-items-center mx-auto">
    <div class="mb-2">
      <div v-if="!displayCroppa">
        <b-img
          v-if="user.profilePic"
          :src="user.profilePic"
          height="150"
          width="150"
          rounded></b-img>
        <b-avatar v-else rounded size="150px" class="mb-2"/>
      </div>
      <croppa
        v-else
        class="rounded"
        v-model="avatar"
        :initial-image="user.profilePic"
        @new-image-drawn="changedAvatar"
        @draw="changedAvatar"
        :height="150"
        :width="150"></croppa>
      <div v-if="displayCroppa">
        <button
          class="btn spnod-admin__form--button btn-secondary btn-sm spnod-button--center"
          @click="avatar.rotate()">
            Rotate
        </button>
      </div>
    </div>
    <h4 class="h4 mb-2">{{ user.name }}</h4>
    <div id="links" class="mb-2 text-center">
      <div id="messaging" class="mb-1" v-if="!myAccount && isAdmin">
        <div v-if="!user.message" class="d-flex">
          <p class="text-muted">Messages</p>
          <span v-if="loadingMessages" class="spinner-border spinner-border-sm text-primary pl-1" role="status" aria-hidden="true"></span>
        </div>
        <router-link
          v-else
          :to="{ name: 'messages', query: { messageId: user.message.messageId, threadId: user.message.threadId } }">
          Messages
        </router-link>
      </div>
    </div>
    <div class="d-flex align-items-center flex-column">
      <a
        class="spnod-admin__form--link mb-1 text-muted"
        href="https://app.termly.io/document/terms-of-use-for-website/6a339b70-c0f6-46e7-ae47-1bb78046b8b9"
        target="_blank">
        Terms of Service
      </a>
      <a
        class="spnod-admin__form--link text-muted"
        href="mailto:support@spnod.com">
        Contact us
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  props: ['user', 'myAccount', 'isAdmin', 'loadingMessages', 'edit'],
  data() {
    return {
      avatar: {}
    }
  },
  computed: {
    displayCroppa() {
      return this.edit && (this.myAccount || this.isAdmin)
    }
  },
  methods: {
    changedAvatar() {
      let avatarData = this.avatar.generateDataUrl()
      if (avatarData !== '' && avatarData !== this.user.profilePic) {
        this.user.profilePic = this.avatar.generateDataUrl()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/UserAccount/Profile.vue?98fc8fbc